import React from "react"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"

const SECTIONS = [
	{
		key: "generale",
		title: "Générale",
		fields: [{ key: "tva", label: "TVA (%)" }],
	},
	{
		key: "atelier",
		title: "Atelier",
		fields: [
			{ key: "coutHoraire", label: "Coût horaire" },
			{ key: "prixHoraire", label: "Prix horaire" },
			{ key: "prixHoraireSociete", label: "Prix horaire société" },
			{ key: "prixHoraireAssurance", label: "Prix horaire assurance" },
		],
	},
	{
		key: "location",
		title: "Location",
		fields: [{ key: "tarifJournalier", label: "Tarif journalier" }],
	},
	// Jordan 30.10 (lot 7) : frais de restitution hors heures du dépannage
	// (modale « Livrer / Restituer ») — 0 = désactivés (défaut).
	{
		key: "depannage",
		title: "Dépannage — restitution hors heures",
		fields: [
			{
				key: "restitutionHorsHeures",
				label: "Frais (0 = désactivés)",
			},
			{
				key: "restitutionDebut",
				label: "Heures ouvrées : début",
				type: "time",
				defaut: "07:00",
			},
			{
				key: "restitutionFin",
				label: "Heures ouvrées : fin",
				type: "time",
				defaut: "18:30",
			},
			{
				key: "restitutionWeekend",
				label: "Week-end hors heures",
				type: "checkbox",
				defaut: true,
			},
		],
	},
]

const styles = {
	sectionTitle: {
		fontSize: 12,
		fontWeight: 600,
		color: COLORS.textLight,
		textTransform: "uppercase",
		letterSpacing: "0.05em",
		marginBottom: 10,
	},
}

// Section "Tarification" du Master : édite entite.extra_data.tarification
// (sous-blocs : générale / atelier / location / dépannage).
const EntiteTarificationV2 = ({ entite, updateTarification }) => {
	const tarif = (entite.extra_data && entite.extra_data.tarification) || {}
	return (
		<div style={gs.card}>
			<div style={gs.cardTitle}>Tarification</div>
			{SECTIONS.map((section, i) => (
				<div key={section.key}>
					<div
						style={{
							...styles.sectionTitle,
							marginTop: i === 0 ? 4 : 20,
						}}
					>
						{section.title}
					</div>
					<div style={gs.fieldGroup}>
						{section.fields.map((f) => (
							<div key={f.key} style={gs.fieldRow}>
								<label style={gs.label}>{f.label}</label>
								{f.type === "checkbox" ? (
									<input
										type="checkbox"
										checked={
											(tarif[section.key] &&
												tarif[section.key][f.key]) ??
											f.defaut
										}
										onChange={(e) =>
											updateTarification(
												section.key,
												f.key,
												e.target.checked,
											)
										}
									/>
								) : (
									<input
										type={f.type || "number"}
										style={gs.input}
										value={
											(tarif[section.key] &&
												tarif[section.key][f.key]) ??
											f.defaut ??
											""
										}
										onChange={(e) =>
											updateTarification(
												section.key,
												f.key,
												e.target.value,
											)
										}
									/>
								)}
							</div>
						))}
					</div>
				</div>
			))}
		</div>
	)
}

export default EntiteTarificationV2
